<template>
  <tr>
    <td>
      {{ item.first_name }}
    </td>
    <td>
      {{ item.last_name }}
    </td>
    <td>
      {{ item.position || '-' }}
    </td>
    <td>
      {{ item.email }}
    </td>
    <td>
      {{ item.phone || '-' }}
    </td>
    <td>
      <div
        v-if="
          $userCheckAccess({
            abilities: 'edit_client_people',
          })
        "
        class="buttons"
      >
        <WorkClientPersonModal :create="false" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-client']['persons-dialog-delete'][
              'udalit-kontakntoe-litso'
            ] +
            ' ' +
            item.first_name +
            ' ' +
            item.last_name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import WorkClientPersonModal from 'components/workClient/person/WorkClientPersonModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkClientPersonTableItem',
  components: { WorkClientPersonModal, DeleteModal },
  props: ['item'],
}
</script>

<style lang="scss" scoped>
td {
  &:nth-child(1) {
    width: auto;
  }
  &:nth-child(2) {
    width: max-content;
  }
  &:nth-child(3) {
    width: auto;
  }
  &:nth-child(4) {
    width: auto;
  }
}
</style>
